import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import {
  Field,
  FieldArray,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import FormTextField from "../../components/formFields/FormTextField";
import {
  emailValidator,
  gstWOValueValidator,
  MobileNoValidator,
  panWOValueValidator,
  passwordValidator,
  pincodeWOValueValidator,
  // passwordValidator,
  requiredValidator,
} from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import RippleButton from "../../components/common/RippleButton";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import ShadowCard from "../../components/common/ShadowCard";

import { getAllActiveCities } from "../city/services/city.services";

import { ICity } from "../city/cityModel";
import { findIndex } from "lodash";
import { IState } from "../state/stateModel";
import { ICountry } from "../country/countryModel";
import { STATUSARRAY, UniversalMarkupType } from "../../_contstants/common";

import { getAllActiveStates } from "../state/services/state.services";
import { getAllActiveCountries } from "../country/services/country.services";

import {
  agentdocumentupload,
  createAgent,
  getAgentByID,
  // updateAgent,
} from "./services/agent.service";
import { clearAgentDetails } from "./agentSlice";

import BankArray from "./BankArray";
import FormImageUpload from "../../components/formFields/FormImageUpload";
import FormPasswordField from "../../components/formFields/FormPasswordField";
import ContactArray from "./ContactArray";
import { ErrorToast } from "../../components/toast/Toasts";

interface CityChangeWatcherProps {
  formRenderProps: FormRenderProps;
  CityList: ICity[];
}

const CityChangeWatcher: React.FC<CityChangeWatcherProps> = ({
  CityList,
  formRenderProps,
}) => {
  const cityID = formRenderProps.valueGetter("CityID");

  useEffect(() => {
    const CityID = cityID ? cityID : undefined;
    const cityIndex = findIndex(CityList, { ID: CityID });
    if (cityIndex > -1) {
      const city = CityList[cityIndex];
      formRenderProps.onChange("StateID", { value: city.StateID });
      formRenderProps.onChange("CountryID", { value: city.CountryID });
    } else {
      formRenderProps.onChange("CityID", { value: "" });
      formRenderProps.onChange("StateID", { value: "" });
      formRenderProps.onChange("CountryID", { value: "" });
    }
  }, [cityID]);
  return null;
};

const CreateAgent: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const AgentID = location.state?.AgentID;
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();

  const loading = useAppSelector((state) => state.agent.loading);
  const AgentDetail = useAppSelector((state) => state.agent.AgentDetail);

  const CityList = useAppSelector((state) => state.city.CityList);
  const StateList = useAppSelector((state) => state.state.StateList);
  const CountryList = useAppSelector((state) => state.country.CountryList);

  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [AgentDetail, CityList]);

  useEffect(() => {
    if (AgentID) {
      dispatch(getAgentByID(AgentID));
    }
    return () => {
      dispatch(clearAgentDetails());
    };
  }, [AgentID]);

  useEffect(() => {
    dispatch(getAllActiveCities());
    dispatch(getAllActiveStates());
    dispatch(getAllActiveCountries());
  }, []);

  const handleSubmit = async (values: any) => {
    const formData = {
      SubAgentName: values.SubAgentName,
      CompanyName: values.CompanyName ? values.CompanyName : "",
      Password: values.Password ? values.Password : "",
      CompanyAddress: values.CompanyAddress ? values.CompanyAddress : "",
      PinCode: values.PinCode ? values.PinCode : "",
      CountryID: values.CountryID ? +values.CountryID : null,
      StateID: values.StateID ? +values.StateID : null,
      CityID: values.CityID ? +values.CityID : null,
      ContactNo: values.ContactNo ? values.ContactNo : "",
      EmailID: values.EmailID,
      GSTNo: values.GSTNo,

      PanNo: values.PanNo,
      AadharNo: values.AadharNo,
      UniversalMarkupTypeID: values.UniversalMarkupTypeID,
      UniversalMarkup: values.UniversalMarkup,
      // AadharDocument: values.AadharDocument,
      // PanDocument: values.PanDocument,
      // GSTDocument: values.GSTDocument,
      // Logo: values.Logo,
      IsActive: values.IsActive === 1,
      ContactDetails: values.ContactDetails
        ? values.ContactDetails.map((contact: any) => {
            return {
              Name: contact.Name ? contact.Name : "",
              MobileNo: contact.MobileNo ? contact.MobileNo : "",
              EmailID: contact.EmailID ? contact.EmailID : "",
              Designation: contact.Designation ? contact.Designation : "",
            };
          })
        : [],

      BankDetails: values.BankDetails
        ? values.BankDetails.map((bank: any) => {
            return {
              BankName: bank.BankName ? bank.BankName : "",
              BranchName: bank.BranchName ? bank.BranchName : "",
              AccountNo: bank.AccountNo ? bank.AccountNo : "",
              IFSCCode: bank.IFSCCode ? bank.IFSCCode : "",
            };
          })
        : [],
    };

    const ImageData = new FormData();
    const AadharDocument =
      values?.AadharDocument && typeof values?.AadharDocument !== "string"
        ? values.AadharDocument[0].getRawFile()
        : "";

    const PanDocument =
      values?.PanDocument && typeof values?.PanDocument !== "string"
        ? values.PanDocument[0].getRawFile()
        : "";

    const GSTDocument =
      values?.GSTDocument && typeof values?.GSTDocument !== "string"
        ? values.GSTDocument[0].getRawFile()
        : "";
    const Logo =
      values?.Logo && typeof values?.Logo !== "string"
        ? values.Logo[0].getRawFile()
        : "";

    try {
      if (AgentID) {
        const editpayload = {
          OperationType: 2,
          ...formData,
          ID: AgentID,
        };

        const response = await dispatch(createAgent(editpayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          if (
            (values.AadharDocument &&
              typeof values.AadharDocument !== "string") ||
            (values.PanDocument && typeof values.PanDocument !== "string") ||
            (values.GSTDocument && typeof values.GSTDocument !== "string") ||
            (values.Logo && typeof values.Logo !== "string")
          ) {
            ImageData.append("AadharDocument", AadharDocument);
            ImageData.append("PanDocument", PanDocument);
            ImageData.append("GSTDocument", GSTDocument);
            ImageData.append("Logo", Logo);
            ImageData.append("ID", AgentID);

            const imageResponse = await dispatch(
              agentdocumentupload(ImageData)
            );
            if (imageResponse?.meta?.requestStatus === "fulfilled") {
              navigate("/agent");
            } else {
              navigate("/agent");
            }
          } else {
            navigate("/agent");
          }
        }
      } else {
        if (values?.ConfirmPassword === values?.Password) {
          const insertpayload = {
            OperationType: 1,
            ...formData,
          };
          const response = await dispatch(createAgent(insertpayload));
          if (response?.meta?.requestStatus === "fulfilled") {
            if (
              ((values?.AadharDocument &&
                typeof values?.AadharDocument !== "string") ||
                (values?.PanDocument &&
                  typeof values?.PanDocument !== "string") ||
                (values?.GSTDocument &&
                  typeof values?.GSTDocument !== "string") ||
                (values?.Logo && typeof values?.Logo !== "string")) &&
              response?.payload?.Data?.ID
            ) {
              ImageData.append("AadharDocument", AadharDocument);
              ImageData.append("PanDocument", PanDocument);
              ImageData.append("GSTDocument", GSTDocument);
              ImageData.append("Logo", Logo);
              ImageData.append("ID", response?.payload?.Data?.ID);

              const imageResponse = await dispatch(
                agentdocumentupload(ImageData)
              );

              if (imageResponse?.meta?.requestStatus === "fulfilled") {
                navigate("/agent");
              } else {
                navigate("/agent");
              }
            } else {
              navigate("/agent");
            }
          }
        } else {
          ErrorToast("Confirm password is incorrect. Please try again");
        }
      }
    } catch (error) {
      console.log("error in hanldle submit", error);
      throw error;
    }
  };

  if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <Form
        key={formKey}
        onSubmit={handleSubmit}
        initialValues={AgentDetail}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <ShadowCard style={{ padding: 12 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem colSpan={3}>
                  <Typography.h4>
                    {AgentID ? "Update Agent" : "Add Agent"}
                  </Typography.h4>
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="SubAgentName"
                    label="Agent Name"
                    placeholder="Agent Name"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="CompanyName"
                    label="Company Name"
                    placeholder="Company Name"
                    astrike={true}
                    validator={requiredValidator}
                    component={FormTextField}
                  />
                </GridLayoutItem>

                <GridLayoutItem>
                  <Field
                    name="CompanyAddress"
                    label="Company Address"
                    placeholder="Company Address"
                    component={FormTextField}
                    astrike={true}
                    validator={requiredValidator}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="PinCode"
                    label="PinCode"
                    component={FormTextField}
                    placeholder="Pincode"
                    minNumber="0"
                    max={6}
                    validator={pincodeWOValueValidator}
                    // validator={requiredValidator}
                  />
                </GridLayoutItem>

                {AgentID ? (
                  ""
                ) : (
                  <>
                    <GridLayoutItem>
                      <Field
                        name={"Password"}
                        type={"password"}
                        component={FormPasswordField}
                        label={"Password"}
                        placeholder="Password"
                        astrike={true}
                        validator={passwordValidator}
                      />
                    </GridLayoutItem>

                    <GridLayoutItem>
                      <Field
                        name={"ConfirmPassword"}
                        type={"password"}
                        component={FormPasswordField}
                        label={"Confirm Password"}
                        placeholder="Confirm Password"
                        astrike={true}
                        validator={passwordValidator}
                      />
                    </GridLayoutItem>
                  </>
                )}

                <GridLayoutItem>
                  <Field
                    id={"CityID"}
                    name={"CityID"}
                    label={"City"}
                    placeholder="i.e. Ahmedabad"
                    component={FormSelectionField}
                    astrike={true}
                    validator={requiredValidator}
                    options={CityList?.map((city: ICity) => {
                      return {
                        value: city?.ID,
                        label: city?.CityName,
                      };
                    })}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    id={"StateID"}
                    name={"StateID"}
                    label={"State"}
                    placeholder="i.e. Gujarat"
                    component={FormSelectionField}
                    disabled={true}
                    astrike={true}
                    // validator={requiredValidator}
                    options={StateList?.map((state: IState) => {
                      return {
                        value: state?.ID,
                        label: state?.StateName,
                      };
                    })}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    id={"CountryID"}
                    name={"CountryID"}
                    label={"Country"}
                    placeholder="i.e. India"
                    component={FormSelectionField}
                    disabled={true}
                    // validator={requiredValidator}
                    astrike={true}
                    validator={requiredValidator}
                    options={CountryList?.map((country: ICountry) => {
                      return {
                        value: country?.ID,
                        label: country?.CountryName,
                      };
                    })}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="ContactNo"
                    label="Mobile No."
                    placeholder="Mobile No."
                    type="number"
                    max={10}
                    component={FormTextField}
                    validator={MobileNoValidator}
                    astrike={true}
                  />
                </GridLayoutItem>

                <GridLayoutItem>
                  <Field
                    name="EmailID"
                    label="Email ID"
                    placeholder="i.e. example@example.com"
                    astrike={true}
                    validator={emailValidator}
                    component={FormTextField}
                  />
                </GridLayoutItem>

                <GridLayoutItem>
                  <Field
                    name="GSTNo"
                    label="GST No"
                    placeholder="GST No"
                    component={FormTextField}
                    validator={gstWOValueValidator}
                    maxLength="15"
                  />
                </GridLayoutItem>

                <GridLayoutItem>
                  <Field
                    name="AadharNo"
                    label="Aadhar No"
                    placeholder="Aadhar No"
                    type="number"
                    component={FormTextField}
                    max={12}
                  />
                </GridLayoutItem>

                <GridLayoutItem>
                  <Field
                    name="PanNo"
                    label="Pan No"
                    placeholder="Pan No"
                    maxLength={10}
                    validator={panWOValueValidator}
                    component={FormTextField}
                  />
                </GridLayoutItem>

                <GridLayoutItem>
                  <Field
                    name="UniversalMarkup"
                    label="Universal Markup"
                    placeholder="Universal Markup"
                    astrike={true}
                    validator={requiredValidator}
                    component={FormTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem colSpan={1}>
                  <Field
                    name={`UniversalMarkupTypeID`}
                    label="Universal Markup Type"
                    component={FormSelectionField}
                    astrike={true}
                    validator={requiredValidator}
                    options={UniversalMarkupType?.map((status: any) => {
                      return {
                        value: status?.value,
                        label: status?.label,
                      };
                    })}
                  />
                </GridLayoutItem>

                <GridLayoutItem>
                  <Field
                    name={`IsActive`}
                    label="Status"
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    placeholder="i.e. Active"
                    options={STATUSARRAY?.map((status: any) => {
                      return {
                        value: status?.value,
                        label: status?.label,
                      };
                    })}
                  />
                </GridLayoutItem>
                {!AgentID && <GridLayoutItem> </GridLayoutItem>}
                <GridLayoutItem>
                  <Field
                    name={`AadharDocument`}
                    label="Aadhar Document"
                    alternateName="Aadhar Document"
                    type="file"
                    accept="image/*"
                    component={FormImageUpload}
                  />
                </GridLayoutItem>

                <GridLayoutItem>
                  <Field
                    name={`PanDocument`}
                    label="PAN Document"
                    alternateName="PAN Document"
                    type="file"
                    accept="image/*"
                    component={FormImageUpload}
                  />
                </GridLayoutItem>
                <GridLayoutItem> </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name={`GSTDocument`}
                    label="GST Document"
                    alternateName="GST Document"
                    type="file"
                    accept="image/*"
                    component={FormImageUpload}
                  />
                </GridLayoutItem>

                <GridLayoutItem>
                  <Field
                    name={`Logo`}
                    style={{ marginLeft: 10 }}
                    label="Logo"
                    alternateName="Logo"
                    type="file"
                    accept="image/*"
                    component={FormImageUpload}
                  />
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
            <ShadowCard style={{ marginTop: "10px" }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem style={{ marginTop: 10 }} colSpan={3}>
                  <FieldArray
                    formRenderProps={formRenderProps}
                    component={ContactArray}
                    name="ContactDetails"
                  />

                  <FieldArray
                    formRenderProps={formRenderProps}
                    component={BankArray}
                    name="BankDetails"
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  colSpan={3}
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "end",
                    marginTop: 20,
                  }}
                >
                  <ButtonWithLoading
                    label={AgentID ? "Update" : "Save"}
                    type="submit"
                    disabled={!formRenderProps.allowSubmit || loading}
                    loading={loading}
                  />

                  <RippleButton
                    type="button"
                    fillMode="outline"
                    themeColor="primary"
                    style={{ marginLeft: 10 }}
                    onClick={() => navigate("/agent")}
                  >
                    Cancel
                  </RippleButton>
                </GridLayoutItem>
              </GridLayout>
              <CityChangeWatcher
                formRenderProps={formRenderProps}
                CityList={CityList}
              />
            </ShadowCard>
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateAgent;
